<template>
  <div v-if="signedIn">
    <div id="app">
      <router-view />
    </div>
  </div>
</template>
<style lang="scss">
@import '../assets/fonts/font-awesome/scss/fontawesome.css';
@import '../assets/globals.scss';
</style>
<script>
import { securityService } from '@/Application/Services/auth/SecurityService';
import axios from 'axios';
import i18n from './lang/index';
import MasterDataService from './Services/MasterDataService';
import momentTimeZone from '../node_modules/moment-timezone';

export default {
  name: 'App',
  data() {
    return {
      mgr: securityService,
      signedIn: false,
      profile: null,
      myBrowserService: {}
    };
  },
  onIdle() {
    securityService.stopSilentRenew();
  },
  onActive() {
    securityService.startSilenRenew();
  },
  mounted() {
    axios.defaults.headers.common['Accept-Language'] = i18n.locale;
    axios.defaults.headers.common['Time-Zone'] = momentTimeZone.tz.guess();
    this.$on('idle', this.onIdle);
    this.$on('active', this.onActive);
    this.mgr.getUser().then(user => {
      axios.defaults.headers.common.Authorization = 'Bearer ' + user.access_token;
      this.profile = user.profile;
      if (this.profile) {
        this.profile.full_name = this.profile.name; 
        this.profile.initials = this.profile.given_name.substring(0, 1).toUpperCase() + this.profile.firstSurname.substring(0, 1).toUpperCase();
      }
      if (this.profile.twoFactor) {
        this.profile.twoFactor = JSON.parse(this.profile.twoFactor);
      }
      this.myBrowserService = new Browser();
      MasterDataService.getFeatureFlag().then(flags => {
        flags.forEach(element => {
          if (this.$store._mutations[`featureFlagsStore/${element}Change`]) {
            this.$store.commit(`featureFlagsStore/${element}Change`, true);
          }
        });
      });
      // Las vistas construyen procesos y listas con el catálogo de grupos y de tipos de personal: no se pintan hasta tenerlos cargados.
      Promise.all([
        this.$store.dispatch('processConfigStore/loadProcessConfigGroups').catch(error => console.log(error)),
        this.$store.dispatch('processConfigStore/loadProcessConfigPersonnelTypes').catch(error => console.log(error))
      ]).finally(() => this.signedIn = true);
    });
  }
};
</script>
